import styled from 'styled-components';

export const Container = styled.section`
  background: #222;
  background-image: -webkit-linear-gradient(top, #222, #333, #333, #222);
  background-image: -moz-linear-gradient(top, #222, #333, #333, #222);
  background-image: -ms-linear-gradient(top, #222, #333, #333, #222);
  background-image: -o-linear-gradient(top, #222, #333, #333, #222);
  border: 1px solid #111;
  border-radius: 5px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.6);
  font-family: Arial, sans-serif;
  height: fit-content;
  min-height: 144px;
  padding: 8px 0;
  position: relative;
  text-align: center;
  width: 465px;

  &:before {
    content: '';
    width: 8px;
    height: 65px;
    background: #444;
    background-image: -webkit-linear-gradient(top, #555, #444, #444, #555);
    background-image: -moz-linear-gradient(top, #555, #444, #444, #555);
    background-image: -ms-linear-gradient(top, #555, #444, #444, #555);
    background-image: -o-linear-gradient(top, #555, #444, #444, #555);
    border: 1px solid #111;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    display: block;
    position: absolute;
    top: 48px;
    left: -10px;
  }

  &:after {
    content: '';
    width: 8px;
    height: 65px;
    background: #442;
    background-image: -webkit-linear-gradient(top, #555, #444, #444, #555);
    background-image: -moz-linear-gradient(top, #555, #444, #444, #555);
    background-image: -ms-linear-gradient(top, #555, #444, #444, #555);
    background-image: -o-linear-gradient(top, #555, #444, #444, #555);
    border: 1px solid #111;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    display: block;
    position: absolute;
    top: 48px;
    right: -10px;
  }
`;
Container.displayName = 'Container';

export const Header = styled.div`
  color: #ffff00;
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  text-shadow: 1px 1px 0px #000;
  text-align: center;
  text-transform: uppercase;
  width: 460px;
  white-space: pre-wrap;
`;
Header.displayName = 'Header';

export const Labels = styled.div`
  margin-top: 8px;
  text-align: center;
  width: 100%;

  & li {
    width: 114px;
    font-size: 15px;
    font-weight: bold;
    color: #ffff00;
    text-shadow: 1px 1px 0px #000;
    text-align: center;
    text-transform: uppercase;
    display: inline-block;
  }
`;
Labels.displayName = 'Labels';

export const Tiles = styled.div`
  position: relative;
  z-index: 1;

  & > span {
    width: 90px;
    max-width: 92px;
    font-size: 60px;
    font-weight: bold;
    text-align: center;
    color: #111;
    background-color: #ddd;
    background-image: -webkit-linear-gradient(top, #bbb, #eee);
    background-image: -moz-linear-gradient(top, #bbb, #eee);
    background-image: -ms-linear-gradient(top, #bbb, #eee);
    background-image: -o-linear-gradient(top, #bbb, #eee);
    border-top: 1px solid #fff;
    border-radius: 3px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.7);
    margin: 0 12px;
    padding: 8px 0;
    display: inline-block;
    position: relative;
  }

  & > span:before {
    content: '';
    width: 100%;
    height: 13px;
    background: #111;
    display: block;
    padding: 0 3px;
    position: absolute;
    top: 41%;
    left: -3px;
    z-index: -1;
  }

  & > span:after {
    content: '';
    width: 100%;
    height: 1px;
    background: #eee;
    border-top: 1px solid #333;
    display: block;
    position: absolute;
    top: 48%;
    left: 0;
  }
`;
Tiles.displayName = 'Tiles';
